import {Component, ReactNode} from 'react';

import type {CaptureInput} from '../../Logger';

interface ErrorBoundaryProps {
  readonly children: ReactNode;
  readonly captureException: (input: CaptureInput) => void;
  readonly layer?: string;
  readonly section?: string;
  readonly onError?: (error: unknown) => void;
}

interface ErrorBoundaryState {
  readonly hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {hasError: false};

  public componentDidCatch(error: unknown): void {
    const {captureException, layer, onError, section} = this.props;

    onError?.(error);
    captureException({error, layer, section});
    this.setState({hasError: true});
  }

  public render(): ReactNode {
    const {children} = this.props;
    const {hasError} = this.state;

    if (hasError) return null;

    return children;
  }
}

export {ErrorBoundary};
